import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieCanada = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose Canada as Your Study Destination?</h1>  
          <p>Canada is globally recognized for combining academic excellence with a vibrant multicultural 
        lifestyle and exceptional quality of life. </p>
        <p>Top Reasons to Study in Canada: </p>
        <ul>
            <li> World-Class Education: Home to top-ranked institutions like the University of Toronto and 
        McGill University. </li>
           <li>Affordable Tuition: Ranges from CAD 7,000 to CAD 29,000 per year.</li>
           <li>Post-Graduation Work Opportunities: Up to 3 years of work permit after studies.</li>
           <li>Pathway to Permanent Residency (PR): Clear immigration pathways like Express Entry.</li>
           <li>Diverse Society: Students from over 200 countries. </li>
           <li>High Safety Standards: Consistently ranked among the safest countries globally. </li>
           <li>Work While Studying: 20 hours/week during semesters; full-time during breaks.</li>
           <li>Universal Healthcare Access: Available in most provinces. </li>
        </ul>

        <hr />
        <table>
            <caption>Quick Facts About Canada</caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Capital</td>
                    <td>Ottawa</td>
                </tr>
                <tr>
                    <td>Largest City</td>
                    <td>Tornoto</td>
                </tr>
                <tr>
                    <td>Population</td>
                    <td>Over 38 Million</td>
                </tr>
                <tr>
                    <td>Global Ranking</td>
                    <td>#2 for Quality of life(Mercer 2021)</td>
                </tr>
                <tr>
                    <td>Langaugaes</td>
                    <td>Over 200 Langaugaes Spoken</td>
                </tr>
        </table>
        <p>Natural Attractions Rocky Mountains, Niagara Falls, National Parks </p>
        <p>Economic Strength Wealthy, stable economy; booming tech and healthcare sectors</p>

        <hr />

        <h2>Education System in Canada</h2>
        <p>Universities :</p>
         <ul>
            <li>Bachelor's, Master's, and Doctoral programs. </li>
            <li>Globally recognized, research-driven education. </li>
            <li>Examples: University of Toronto, UBC, McGill University. </li>
         </ul>
         <p>Colleges :</p>
         <ul>
            <li>Career-focused diploma and certificate programs.  </li>
            <li>Emphasis on practical and vocational training.  </li>
            <li>Examples: Humber College, George Brown College, Centennial College.  </li>
         </ul>
         <p>Polytechnics: </p>
         <ul>
            <li>Specialized applied education in engineering, business, healthcare, and technology.   </li>
            <li>Examples: BCIT, Seneca College.   </li>
         </ul>
         <hr />
         <h2>Popular Programs in Canada </h2>

         <table>
            <thead>
                <tr>
                    <th>Level </th>
                    <th>Duration</th>
                    <th>Fields</th>
                    <th>Admission Requirements</th>
                    <th>Tuition (per year)</th>
                    <th>Top Institutions </th>
                </tr>
            </thead>
                <tr>
                    <td>UG</td>
                    <td>3–4 years </td>
                    <td>Engineering, Business, Arts, Science </td>
                    <td>12th Grade + IELTS 6.0 </td>
                    <td>CAD 7,000 – 29,000 </td>
                    <td>U of T, UBC, McGill</td>
                </tr>
                <tr>
                    <td>PG</td>
                    <td>1–2 years</td>
                    <td>Management, IT, Health Sciences </td>
                    <td>Bachelor’s Degree + IELTS 6.5 </td>
                    <td>CAD 13,000 – 25,000</td>
                    <td>McGill, Waterloo, Queen’s </td>
                </tr>
                <tr>
                    <td>PG Diploma</td>
                    <td>1–2 years</td>
                    <td>Hospitality, Business, Design, IT </td>
                    <td>UG Degree + IELTS 6.0 </td>
                    <td>CAD 10,000 – 18,000</td>
                    <td>Seneca, George Brown, Centennial </td>
                </tr>    
        </table>
        <hr />
        <h2>Cost of Studying in Canada</h2>
        <table>
            <thead>
                <tr>
                    <th>Program Type</th>
                    <th>Annual Tuition Fees </th>
                </tr>
            </thead>
                <tr>
                    <td>Bachelor's Degree </td>
                    <td>CAD 7,000 – 29,000</td>
                </tr>
                <tr>
                    <td>Master's Degree</td>
                    <td>CAD 13,000 – 35,000</td>
                </tr>
                <tr>
                    <td>PG Diploma</td>
                    <td>CAD 10,000 – 18,000 </td>
                </tr>
                </table>
                <p>Living Expenses: Approx. CAD 10,000 – 15,000 per year depending on location.</p>
                <hr/>
                <h2>Scholarships for International Students</h2>
                <p>Dream Destination supports you in securing scholarships to ease your financial burden.</p>
                <p>Scholarship Highlights: </p>
                <ul>
                    <li>Master’s Scholarships: Tuition coverage or living stipends based on merit.</li>
                    <li>Bachelor’s Scholarships: Ranging from CAD 2,000 to CAD 20,000. </li>
                    <li>PG Diploma Scholarships: Entrance scholarships and tuition discounts. </li>
                </ul>
                <p>Selection criteria include academic performance, leadership, and community involvement.</p>
            <hr />
            <h2>Admission Requirements</h2>
            <table>
            <thead>
                <tr>
                    <th>Program</th>
                    <th>Academic Requirements</th>
                    <th>Language Requirements</th>
                    <th>Additional Documents </th>
                </tr>
            </thead>
                <tr>
                    <td>Bachelor's Degree </td>
                    <td>65%–80% in 12th Grade</td>
                    <td>IELTS 6.0 (no band below 5.5) </td>
                    <td>SOP, LORs, Resume, Passport</td>
                </tr>
                <tr>
                    <td>Master's Degree</td>
                    <td>4-Year UG Degree (70%+)</td>
                    <td>IELTS 6.5–7.0 </td>
                    <td>SOP, LORs, Resume, Transcripts</td>
                </tr>
                <tr>
                    <td>PG Diploma</td>
                    <td>3- or 4-Year UG Degree (55%–65%) </td>
                    <td>IELTS 6.0 </td>
                    <td>Resume, SOP, Transcripts, Work Experience (if applicable) </td>
                </tr>
                </table>
            <hr />
            <h2>Canada Study Visa: SDS vs Non-SDS Process </h2>
            <table>
            <thead>
                <tr>
                    <th>Feature</th>
                    <th>SDS (Student Direct Stream) </th>
                    <th>Non-SDS </th>
                </tr>
            </thead>
                <tr>
                    <td>Eligibility</td>
                    <td>65%–80% in 12th GradeCitizens of India, China, Vietnam, Philippines</td>
                    <td> All other international students</td>
                </tr>
                <tr>
                    <td>Processing Time</td>
                    <td>Approx. 20 days </td>
                    <td>6–8 weeks</td>
                </tr>
                <tr>
                    <td>Language Test </td>
                    <td>IELTS 6.0 minimum per band </td>
                    <td>IELTS/TOEFL/Duolingo</td>
                </tr>
                <tr>
                    <td>Tuition Fee Payment</td>
                    <td> Full one-year payment upfront</td>
                    <td>Partial payment accepted</td>
                </tr>
                <tr>
                    <td>GIC (CAD 10,000)</td>
                    <td>Mandatory </td>
                    <td>Optional</td>
                </tr>
                </table>
            <hr />
            <h2>Work Opportunities in Canada </h2>
            <p> During Studies: </p>
            <ul>
                <li>20 hours/week during semesters. </li>
                <li>Full-time during scheduled breaks. </li>
                <li>Average Wage: CAD 13–20 per hour. </li>
            </ul>
            <p> After Graduation:  </p>
            <ul>
                <li>Eligible for Post-Graduation Work Permit (PGWP) — up to 3 year </li>
                <li>Valuable Canadian work experience for PR pathways.</li>
            </ul>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieCanada